import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
import './Contact.css';
import FieldCustom from '../styledComponents/Field';

gsap.registerPlugin(ScrollTrigger, SplitText);

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
//orange theme for textfields, lists and radiobuttons
const theme = createTheme({
	palette: {
		primary: {
			main: '#ff5f00',
		},
		mode: 'dark',
		text: {
			primary: '#FFFFFF',
			secondary: 'rgba(255,255,255,0.9)',
		},
		divider: 'rgba(255,255,255,0.12)',
	},

	typography: {
		fontFamily: 'brother-1816',
	},
	transitions: {
		duration: { complex: '500' },
	},
});

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	maxWidth: 400,
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4,
};

const Contact = () => {
	const contactForm = useRef();
	const [contactMessage, setContactMessage] = useState(false);
	const { register, handleSubmit } = useForm();
	const main = useRef();
	const [enter, setEnter] = useState(false);
	const anim = () => {
		let quote2 = document.querySelector('.title-header');

		let splitSecondLine = SplitText.create(quote2, { type: 'words' });

		gsap.fromTo(
			splitSecondLine.words,
			{
				opacity: 0,
				color: '#ff5f00',
				// ease: 'back',
				duration: 1,
				stagger: 0.1,
				scale: 4,
				y: -100,
			},
			{
				opacity: 1,
				color: '#ff5f00',
				// ease: 'back',
				duration: 1,
				stagger: 0.1,
				scale: 1,
				y: 0,
			}
		);
	};
	useEffect(() => {
		const ctx = gsap.context(() => {
			enter && anim();
		}, main);
		return () => {
			ctx.revert();
		};
	}, [enter]);

	useEffect(() => {
		const ctx = gsap.context(() => {
			const tl = gsap.timeline();
			tl.from('.contact-form-name', {
				x: `-${window.innerWidth * 0.1}`,
				duration: 1.2,
				ease: 'power3.out',
			});
			tl.from(
				'.contact-form-email',
				{
					x: `${window.innerWidth * 0.1}`,
					duration: 1.2,
					ease: 'power3.out',
				},
				'-=1.2'
			);
			tl.from(
				'.contact-form-message',
				{
					y: `${window.innerHeight * 0.1}`,
					duration: 1.2,
					ease: 'power3.out',
				},
				'-=1.2'
			);
			tl.from(
				'.contact-form-human-checkbox',
				{
					y: `${window.innerHeight * 0.1}`,
					duration: 1.2,
					ease: 'power3.out',
				},
				'-=1.2'
			);

			tl.from(
				'.contact-form-submit-button',
				{
					y: `${window.innerHeight * 0.1}`,
					duration: 1.2,
					ease: 'power3.out',
				},
				'-=1.2'
			);
			tl.from(
				'.contact-form-human-checkbox-label',
				{
					y: `${window.innerHeight * 0.1}`,
					duration: 1.2,
					ease: 'power3.out',
				},
				'-=1.2'
			);

			ScrollTrigger.create({
				trigger: '.contact-form-container',
				start: 'top 70%',
				toggleActions: 'play none none reverse',
				animation: tl,
			});
		});
		return () => {
			ctx.revert();
		};
	}, []);

	const handleSumitContact = async (data) => {
		try {
			if (data.checkHuman) {
				const body = {
					firstname: data.Firstname,
					lastname: data.Lastname,
					email: data.email,
					message: data.message,
				};
				// const url = 'http://localhost:8080/contact';
				const url = 'https://grouped--grouped--gsmxcbzt8tzm.code.run/portfolio/contact';
				const response = await axios.post(url, body);
				if (response.data === 'received message') {
					setContactMessage(true);
				}
			}
		} catch (error) {
			console.log(error.message);
		}
	};

	return (
		<>
			<section
				className="contact-form-container"
				onMouseEnter={() => {
					setEnter(true);
				}}
			>
				<div className="title-header">Feel free to contact me </div>
				<div
					className="contact-form"
					ref={contactForm}
				>
					<ThemeProvider theme={theme}>
						<form onSubmit={handleSubmit(handleSumitContact)}>
							<div className="contact-form-name">
								<FieldCustom
									register={register}
									label={'Firstname'}
								></FieldCustom>

								<FieldCustom
									register={register}
									label={'Lastname'}
								></FieldCustom>
							</div>
							<div className="contact-form-email-message contact-form-email">
								<FieldCustom
									register={register}
									label={'email'}
								></FieldCustom>
							</div>
							<div className="contact-form-email-message contact-form-message">
								<FieldCustom
									register={register}
									label={'message'}
									multiline={true}
									rows={6}
								></FieldCustom>
							</div>
							<div className="">
								<Checkbox
									className="contact-form-human-checkbox"
									{...label}
									required
									{...register('checkHuman')}
								/>
								<span className="contact-form-human-checkbox-label">I'am not a robot</span>
							</div>
							<div className="contact-form-submit-button">
								<Button
									type="submit"
									variant="contained"
									fullWidth
									sx={{ fontSize: 18, fontFamily: 'brother-1816' }}
								>
									Send
								</Button>
							</div>
						</form>
					</ThemeProvider>
				</div>
			</section>
			{contactMessage && (
				<Modal
					open={contactMessage}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Typography
							id="modal-modal-title"
							variant="h6"
							component="h2"
						>
							<div className="contact-modal-content">
								<div>Thanks for sending me a messgage</div>
								<div
									className="contact-modal-close"
									onClick={() => {
										setContactMessage(false);
									}}
								>
									<ion-icon name="close-circle-outline"></ion-icon>
								</div>
							</div>
						</Typography>
					</Box>
				</Modal>
			)}
		</>
	);
};
export default Contact;
